import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_utilities'

export const elements = object(null, {
  rte: `${block}__rte`,
})

export const modifiers = object(null, {
  rte: object(null, {
    highlight: `${elements.rte}-highlight`,
  }),
})
